import { FC, useEffect } from "react"
import UploadPhoto from "@pages/makeEvent/layout/common/uploadPhoto"
import { EventAddPhotoComponentProps } from "@pages/makeEvent/types"
import s from "@pages/makeEvent/steps-components/eventAddPhoto-component/styles.module.css"


const isAvatarsValid = (avatars?: string[]): boolean => {
		return (
			Array.isArray(avatars) &&
			avatars.length > 0 &&
			avatars.every((avatar) => avatar?.trim() !== "")
		)
	}

const AddPhotoComponent: FC<EventAddPhotoComponentProps> = ({ formik, addPhoto, photo, setHasValidPhoto }) => {
	const avatars = formik.values.avatars_for_adding as Array<string>

	useEffect(() => {
		const isAnyValidPhoto = isAvatarsValid(avatars)
    setHasValidPhoto(isAnyValidPhoto)
	}, [formik.values])

	return (
		<div className={s.content}>
			<UploadPhoto
				photo={photo[0]}
				setPhoto={(imgArrBuf: string, imgDataUrl: string) => {
					addPhoto(imgArrBuf, imgDataUrl, 0)
				}}
			/>
			<div className={s.sub_content}>
				<UploadPhoto
					photo={photo[1]}
					setPhoto={(imgArrBuf: string, imgDataUrl: string) => {
						addPhoto(imgArrBuf, imgDataUrl, 1)
					}}
				/>
				<UploadPhoto
					photo={photo[2]}
					setPhoto={(imgArrBuf: string, imgDataUrl: string) => {
						addPhoto(imgArrBuf, imgDataUrl, 2)
					}}
				/>
			</div>
		</div>
	)
}

export default AddPhotoComponent